<template>
  <b-nav-item
    v-if="isPermitted('seeApprovals')"
    right
    :title="count"
    @click="navToApproval"
  >
    <feather-icon
      :badge="badge"
      badge-classes="bg-danger"
      class="text-body"
      icon="CheckCircleIcon"
      size="21"
    />
  </b-nav-item>
</template>

<script>
import {
  BNavItem,
} from 'bootstrap-vue'
import { getUserData, isPermitted } from '@/auth/utils'

export default {
  components: {
    BNavItem,
  },
  data() {
    return {
      badge: null,
      count: null,
    }
  },
  created() {
    this.userData = getUserData()
  },
  mounted() {
    this.$root.$on('approval_count', count => {
      this.count = count
      this.badge = count > 100 ? '!' : count
    })
  },
  beforeDestroy() {
    this.$root.$off('approval_count')
  },
  methods: {
    isPermitted(code) {
      if (!this.userData) {
        return false
      }
      return isPermitted(this.userData.role, code, this.userData.userGroups)
    },
    navToApproval() {
      if (this.$route.path !== '/approval') this.$router.push({ name: 'approval' })
    },
  },
}
</script>

<style>

</style>
